class LinkConfirmManager {
    constructor(parent, data) {
        // Optionally pass a container element as 'parent'. If not provided, document is used.
        this.parent = parent || document;
        this.data = data;
        this.init();
    }

    init() {
        // Find all elements with the data-confirm attribute within the parent container.
        document.querySelectorAll('[data-confirm]').forEach((el) => {
            new LinkConfirmItem(el, this);
        });
    }
}

class LinkConfirmItem {
    constructor(item, parent) {
        this.item = item;
        this.parent = parent;
        this.init();
    }

    init() {
        // Bind the click event on the element to the handleClick method.
        this.item.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
        // Get the confirmation message from the data-confirm attribute or use a default message.
        const message = this.item.getAttribute('data-confirm') || 'Tem a certeza de que quer sair?';

        // Show the confirmation dialog; if the user cancels, prevent the link from navigating.
        if (!window.confirm(message)) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
}

export default LinkConfirmManager;
